// extracted by mini-css-extract-plugin
export default {"picker":"PopoverPicker_picker__Rxl7F","swatch":"PopoverPicker_swatch__XwdUA","popover":"PopoverPicker_popover__1X05H","colorSelect":"PopoverPicker_colorSelect__f+tTV"};